export const excludeDeniedOwnerFields = <T extends { isDeniedOwnerField?: boolean }>(columns: readonly T[]): T[] =>
    columns.filter((column) => !column.isDeniedOwnerField);
